module.exports = __webpack_public_path__ + "img/e_3_9_g.a730798b.png";